import type { Messages } from '@/types'

// Placeholder Portuguese translations - to be completed with proper translations
const messages: Messages = {
    common: {
        actions: {
            add: 'Adicionar',
            edit: 'Editar',
            delete: 'Eliminar',
            cancel: 'Cancelar',
            back: 'Voltar',
            save: 'Guardar',
            update: 'Atualizar',
            reset: 'Repor',
            refresh: 'Atualizar',
            backToList: '@:common.back à lista',
            resetDefaults: '@:common.reset aos valores padrão',
            confirm: 'Confirmar',
            proceed: 'Continuar',
            close: 'Fechar',
            apply: 'Aplicar',
            search: 'Pesquisar',
            filter: 'Filtrar',
            clear: 'Limpar',
            select: 'Selecionar',
            upload: 'Carregar',
            download: 'Descarregar',
            view: 'Ver',
            sort: 'Ordenar',
            seeMore: 'Ver mais'
        },
        status: {
            success: 'Sucesso',
            error: 'Erro',
            loading: 'A carregar...'
        },
        messages: {
            deleteConfirm: 'Tem a certeza de que deseja eliminar este utilizador?',
            generalError: 'Algo correu mal! Por favor, tente novamente',
            addSuccess: 'Registo adicionado com sucesso!',
            updateSuccess: 'Registo atualizado com sucesso!',
        },
        placeholder: {
            avatar: '?'
        },
        labels: {
            loading: 'A carregar',
            noResults: 'Nenhum resultado encontrado',
            noData: 'Nenhum dado disponível',
            selected: 'Selecionado',
            required: 'Obrigatório',
            optional: 'Opcional',
            search: 'Pesquisar...',
            filter: 'Filtrar...',
            from: 'De',
            to: 'Até',
            date: 'Data',
            status: 'Estado',
            item: 'Item {index}',
            addItem: 'Adicionar Item',
            removeItem: 'Remover Item',
            skipToMain: 'Saltar para o conteúdo principal',
            openNavigation: 'Abrir navegação',
            closeNavigation: 'Fechar navegação',
            mainNavigation: 'Navegação principal',
            moveUp: 'Mover para Cima',
            moveDown: 'Mover para Baixo'
        },
        errors: {
            upload: 'Falha ao carregar ficheiro',
            download: 'Falha ao descarregar ficheiro',
            generic: 'Ocorreu um erro',
            notFound: 'Não encontrado',
            unauthorized: 'Acesso não autorizado',
            validation: 'Por favor, verifique a sua entrada'
        },
        validation: {
            required: 'Este campo é obrigatório',
            email: 'Endereço de email inválido',
            minLength: 'Comprimento mínimo é {length}',
            maxLength: 'Comprimento máximo é {length}',
            min: 'Valor mínimo é {min}',
            max: 'Valor máximo é {max}',
            matches: 'Formato inválido',
            unique: 'O valor deve ser único',
            confirm: 'As palavras-passe não correspondem'
        }
    },
    pages: {
        users: {
            title: 'Utilizadores',
            description: 'Gerir utilizadores do sistema',
            actions: {
                invite: 'Convidar Utilizador',
                resetPassword: 'Repor Palavra-passe'
            }
        },
        settings: {
            title: 'Definições',
            actions: {
                resetDefaults: 'Repor aos valores padrão'
            }
        },
        reports: {
            title: 'Relatórios',
            description: 'Gerar e descarregar relatórios',
            actions: {
                generateReport: 'Gerar Relatório',
                downloadCsv: 'Descarregar CSV',
                startDate: 'Data de Início',
                endDate: 'Data de Fim',
                apps: 'Aplicações',
            },
            error: {
                generation: 'Falha ao gerar relatório',
                download: 'Falha ao descarregar relatório'
            }
        }
    },
    navigation: {
        home: 'Início',
        library: 'Biblioteca',
        search: 'Pesquisar',
        login: 'Entrar',
        signInToGetPremium: 'Obter Premium',
        subscribe: 'Subscrever',
        support: 'Suporte',
        settings: 'Definições',
        logout: 'Terminar sessão'
    },
    settings: {
        title: 'Definições',
        description: 'Gerir as definições da sua conta, preferências e informações do perfil.',
        sections: 'Secções de Definições',
        menu: {
            profile: 'Perfil',
            account: 'Conta',
            general: 'Geral',
            purchases: 'Compras',
            activity: 'Atividade'
        },
        profile: {
            title: 'Perfil',
            changeImage: 'Alterar Imagem',
            updateProfile: 'Atualizar Perfil',
            changePassword: 'Alterar Palavra-passe',
            updatePassword: 'Atualizar Palavra-passe',
            fields: {
                fullName: 'Nome Completo',
                emailAddress: 'Endereço de Email',
                dateOfBirth: 'Data de Nascimento',
                currentPassword: 'Palavra-passe Atual',
                newPassword: 'Nova Palavra-passe',
                confirmNewPassword: 'Confirmar Nova Palavra-passe'
            },
            toasts: {
                imageUpdated: 'Imagem Atualizada',
                imageUpdatedMessage: 'A sua imagem de perfil foi atualizada com sucesso',
                uploadFailed: 'Carregamento Falhado',
                profileUpdated: 'Perfil Atualizado',
                profileUpdatedMessage: 'O seu perfil foi atualizado com sucesso',
                passwordUpdated: 'Palavra-passe Atualizada',
                passwordUpdatedMessage: 'A sua palavra-passe foi atualizada com sucesso',
                passwordError: 'Erro na Palavra-passe',
                passwordMismatch: 'As palavras-passe não coincidem',
                passwordTooWeak: 'A palavra-passe é muito fraca'
            }
        },
        account: {
            title: 'Conta',
            accountInformation: 'Informações da Conta',
            emailAddress: 'Endereço de Email',
            memberSince: 'Membro desde',
            redeemPromoCode: 'Resgatar código promocional',
            redeemPromoCodeDescription: 'Tem um código promocional ou de oferta? Introduza-o aqui para aplicá-lo à sua conta ou próxima subscrição.',
            subscription: {
                title: 'Subscrição',
                currentPlan: 'Plano Atual',
                premiumSubscription: 'Subscrição Premium',
                nextRenewal: 'Próxima renovação:',
                accessUntil: 'Acesso até:',
                manageInAppStore: 'A sua subscrição foi comprada através da App Store. Para a cancelar ou alterar, abra Subscrições nas definições do seu Apple ID no dispositivo que usou para subscrever.',
                manageInPlayStore: 'A sua subscrição foi comprada através do Google Play. Para a cancelar ou alterar, abra Subscrições na Google Play Store no dispositivo que usou para subscrever.',
                notSubscribed: 'Não está atualmente subscrito a nenhum plano.',
                subscribeNow: 'Subscrever Agora',
                findOutMore: 'Saber mais',
                cancelSubscription: 'Cancelar Subscrição',
                cancelSubscriptionTitle: 'Cancelar Subscrição',
                cancelSubscriptionMessage: 'Tem a certeza de que deseja cancelar a sua subscrição? Perderá o acesso ao conteúdo premium no final do período de faturação atual.',
                keepSubscription: 'Manter Subscrição',
                toasts: {
                    subscriptionActivated: 'Subscrição Ativada',
                    subscriptionActivatedMessage: 'Bem-vindo ao Premium!',
                    subscriptionFailed: 'Subscrição Falhada',
                    paymentMethodUpdated: 'Método de Pagamento Atualizado',
                    paymentMethodUpdatedMessage: 'As suas informações de pagamento foram atualizadas com sucesso',
                    subscriptionCancelled: 'Subscrição Cancelada',
                    subscriptionCancelledMessage: 'A sua subscrição terminará no período de faturação atual',
                    cancellationFailed: 'Cancelamento Falhado'
                }
            },
            closeAccount: {
                title: 'Fechar Conta',
                requestDescription: 'Solicitar o encerramento permanente da sua conta. Esta ação não pode ser desfeita.',
                requestButton: 'Solicitar Encerramento da Conta',
                confirmationTitle: 'Tem a certeza de que deseja desativar a sua conta? Isto irá:',
                confirmationItems: {
                    cancelSubscription: 'Cancelar a sua subscrição ativa (se houver)',
                    removeCommunications: 'Removê-lo de todas as comunicações',
                    scheduleDeletion: 'Agendar a eliminação permanente dos seus dados após 30 dias'
                },
                confirmationWarning: 'Pode cancelar o seu pedido de desativação a qualquer momento dentro de 30 dias. Após este período, a sua conta e todos os dados associados serão permanentemente eliminados.',
                confirmationCheckbox: 'Compreendo que a minha conta será permanentemente eliminada após 30 dias',
                deactivateAccount: 'Desativar Conta',
                cancel: 'Cancelar',
                scheduledTitle: 'Desativação da Conta Agendada',
                scheduledMessage: 'A sua conta está agendada para ser permanentemente eliminada em',
                scheduledWarning: 'Durante este período, não poderá iniciar sessão na sua conta. Se mudar de ideias, pode cancelar o processo de desativação.',
                cancelDeactivation: 'Cancelar Desativação da Conta',
                toasts: {
                    deactivationRequested: 'Desativação da Conta Solicitada',
                    deactivationRequestedMessage: 'A sua conta será permanentemente eliminada em 30 dias',
                    deactivationFailed: 'Desativação Falhada',
                    deactivationCancelled: 'Desativação Cancelada',
                    deactivationCancelledMessage: 'A sua conta já não está agendada para eliminação'
                }
            }
        },
        purchases: {
            title: 'Histórico de Compras',
            noPurchases: 'Nenhuma compra encontrada',
            invoice: 'Fatura'
        },
        activity: {
            title: 'Linha do Tempo de Atividade',
            dateRange: 'Intervalo de Datas',
            activityType: 'Tipo de Atividade',
            noActivities: 'Nenhuma atividade encontrada',
            resume: 'Retomar',
            loadMore: 'Carregar Mais',
            filters: {
                last7Days: 'Últimos 7 dias',
                last30Days: 'Últimos 30 dias',
                lastYear: 'Último ano',
                allTime: 'Todo o tempo',
                allActivities: 'Todas as Atividades',
                listening: 'A Ouvir',
                purchases: 'Compras',
                likes: 'Gostos',
                bookmarks: 'Marcadores'
            },
            types: {
                listenedTo: 'Ouvido {title}',
                purchased: 'Comprado {title}',
                liked: 'Gostou de {title}',
                bookmarked: 'Marcou {title}'
            }
        },
        appSettings: {
            title: 'Definições da Aplicação',
            darkMode: 'Modo Escuro',
            language: 'Idioma',
            languageOptions: {
                english: 'Inglês',
                spanish: 'Espanhol',
                french: 'Francês',
                german: 'Alemão',
                italian: 'Italiano',
                portuguese: 'Português',
                dutch: 'Holandês',
                slovak: 'Eslovaco',
                russian: 'Russo',
                arabic: 'العربية'
            }
        },
        notifications: {
            title: 'Notificações',
            emailNotifications: 'Notificações por Email',
            emailNotificationsHint: 'Receber atualizações por email',
            pushNotifications: 'Notificações Push',
            pushNotificationsHint: 'Receber notificações push',
            updatePreferences: 'Atualizar Preferências'
        },
        toasts: {
            themeUpdated: 'Tema Atualizado',
            themeUpdatedMessage: 'A sua preferência de tema foi guardada',
            languageUpdated: 'Idioma Atualizado',
            languageUpdatedMessage: 'A sua preferência de idioma foi guardada',
            preferencesUpdated: 'Preferências Atualizadas',
            preferencesUpdatedMessage: 'As suas preferências de notificação foram guardadas',
            updateFailed: 'Atualização Falhada',
            updateFailedMessage: 'Falha ao atualizar definição',
            updateFailedNotificationMessage: 'Falha ao atualizar preferências de notificação'
        }
    },
    auth: {
        login: {
            title: 'Iniciar Sessão',
            description: 'Inicie sessão na sua conta Heard para aceder à sua biblioteca e conteúdo premium',
            signIn: 'Iniciar Sessão',
            signInToAccount: 'Inicie sessão na sua conta',
            noAccount: 'Não tem uma conta?',
            signUp: 'Registar-se',
            continueAsGuest: 'Continuar como convidado',
            or: 'Ou',
            agreeToTerms: 'Ao iniciar sessão, concorda com os nossos',
            termsOfService: 'Termos de Serviço',
            privacyPolicy: 'Política de Privacidade'
        },
        register: {
            title: 'Registar-se',
            description: 'Crie uma nova conta Heard para aceder à sua biblioteca e conteúdo premium'
        }
    },
    player: {
        chapters: 'Capítulos',
        options: 'Opções',
        playbackSpeed: 'Velocidade de Reprodução',
        share: 'Partilhar',
        linkCopied: 'Link Copiado',
        linkCopiedMessage: 'Link de partilha copiado para a área de transferência!',
        shareError: 'Erro ao Partilhar',
        shareErrorMessage: 'Não foi possível copiar o link. Por favor, tente novamente.',
        bookmarkAdded: 'Sucesso',
        bookmarkAddedMessage: 'Marcador adicionado!',
        jumpedToBookmark: 'Sucesso',
        jumpedToBookmarkMessage: 'Saltar para o marcador!',
        likeError: 'Erro ao Gosto',
        likeErrorMessage: 'Não foi possível atualizar o estado de gosto. Por favor, tente novamente.',
        bookmarkError: 'Erro ao Marcador',
        bookmarkErrorMessage: 'Não foi possível atualizar o marcador. Por favor, tente novamente.',
        favorites: {
            add: 'Adicionar aos Favoritos',
            remove: 'Remover dos Favoritos'
        },
        unknownChapter: 'Capítulo Desconhecido',
        unknownTitle: 'Título Desconhecido',
        unknownAuthor: 'Autor Desconhecido'
    },
    details: {
        starring: 'Protagonistas:',
        author: 'Autor',
        narrator: 'Narrador',
        pause: 'Pausar',
        purchased: 'Comprado',
        continueReading: 'Continuar a Ler',
        continuePlaying: 'Continuar a Reproduzir',
        play: 'Reproduzir',
        loading: 'A carregar...',
        noChapters: 'Nenhum capítulo disponível',
        chapterFreeLabel: 'Grátis',
        listen: 'Ouvir',
        purchaseSuccess: 'Compra bem-sucedida',
        purchaseSuccessMessage: '{title} foi adicionado à sua biblioteca',
        subscriptionSuccess: 'Subscrição bem-sucedida',
        subscriptionSuccessMessage: 'Bem-vindo ao Heard Premium!',
        subscriptionFailed: 'Subscrição falhada',
        subscriptionErrorMessage: 'Ocorreu um erro ao processar a sua subscrição.',
        info: 'Info',
        more: 'Mais',
        episodes: 'Episódios',
        about: 'Sobre',
        series: 'Série',
        producedBy: 'Produzido por',
        recommendations: 'Também poderá gostar',
        moreFromCategory: 'Mais de {name}',
        moreFromAuthor: 'Mais de {name}',
        moreFromCast: 'Mais de {name}',
        moreFromSeries: 'Mais em {name}',
        noRelated: 'Não há títulos relacionados disponíveis de momento.',
        ageVerification: {
            title: 'Apenas para adultos',
            message: 'Este conteúdo é apenas para adultos. Confirme que pretende continuar.',
            minAgeHint: 'Tem de ter pelo menos {age} anos para ver este título.',
            confirm: 'Sou adulto, continuar',
            cancel: 'Cancelar',
            missingDobTitle: 'Data de nascimento necessária',
            missingDobMessage: 'Adicione a data de nascimento no perfil para ver este conteúdo.',
            underageTitle: 'Restrito por idade',
            underageMessage: 'Tem de ter pelo menos {age} anos para ver este conteúdo.',
        },
    },
    shareModal: {
        title: 'Partilhar',
        copyLink: 'Copiar link',
        copyLinkWithMessage: 'Copiar link com mensagem',
        copyLinkWithMessageHint: 'Título e descrição incluídos',
        shareVia: 'Partilhar via...',
        shareViaHint: 'Apps, mensagens, email',
        linkCopied: 'Link copiado',
        linkCopiedMessage: 'Link copiado para a área de transferência!',
        shared: 'Partilhado',
        sharedMessage: 'Conteúdo partilhado com sucesso'
    },
    contextMenu: {
        playFromBeginning: 'Reproduzir desde o Início',
        markAsFinished: 'Marcar como Concluído',
        addToFavorites: 'Adicionar aos Favoritos',
        removeFromFavorites: 'Remover dos Favoritos',
        share: 'Partilhar',
        viewDetails: 'Ver Detalhes',
        removeFromLibrary: 'Remover da Biblioteca',
        continuePlaying: 'Continuar a Reproduzir',
        continueReading: 'Continuar a Ler'
    },
    actions: {
        subscribe: 'Subscrever',
        signInToGetPremium: 'Obter Premium',
        purchase: 'Comprar',
        buy: 'Comprar',
        buyFor: 'Comprar por {price}',
        purchasedGoToLibrary: 'Comprado - Ir para a Biblioteca',
        addToFavorites: 'Adicionar aos favoritos',
        removeFromFavorites: 'Remover dos favoritos',
        share: 'Partilhar'
    },
    browse: {
        sortBy: 'Ordenar por',
        sortOptions: {
            recent: 'Recentes',
            ascending: 'A-Z',
            descending: 'Z-A'
        }
    },

    legal: {
        companyNumber: 'N.º da empresa',
        privacyPolicy: 'Política de privacidade',
        termsOfService: 'Termos de serviço',
        agreeToTermsSubscribe: 'Ao subscrever, concorda com os nossos',
        operatedBy: '{appName} é operado por {companyName}, {address}',
        faqs: 'FAQ'
    },
    support: {
        title: 'Suporte',
        description: 'Precisa de ajuda com a sua conta, subscrição ou experiência de audição? Consulte as nossas FAQs e informações legais, ou envie-nos uma mensagem.',
        intro: 'Precisa de ajuda com a sua conta, subscrição ou experiência de audição? Consulte as nossas FAQs e informações legais abaixo, ou contacte-nos se precisar de mais assistência.',
        quickLinks: 'Links rápidos',
        contactTitle: 'Contactar suporte',
        contactDescription: 'Envie uma mensagem à nossa equipa de suporte. Consulte primeiro as FAQs para respostas rápidas.',
        contactIntro: 'Se precisar de ajuda, estamos aqui para si. Muitas perguntas comuns já estão respondidas no nosso centro de ajuda.',
        contactIntroFaqBefore: 'Consulte as nossas ',
        contactIntroFaqAfter: ' para respostas a perguntas comuns. Se ainda precisar de ajuda, preencha o formulário e responderemos o mais breve possível.',
        contactSubmit: 'Enviar mensagem',
        contactName: 'Nome',
        contactEmail: 'E-mail',
        contactSubject: 'Assunto',
        contactMessage: 'Mensagem',
        contactMessageHint: 'Descreva o seu problema em detalhe',
        backToSupport: 'Voltar ao suporte',
        pageLoading: 'A carregar…',
        pageNotAvailable: 'Esta página não está disponível de momento.',
        unsupportedSection: 'Secção de conteúdo não suportada: {name}',
        useContactFormBefore: 'Precisa de entrar em contacto? Use o nosso ',
        contactSuccessTitle: 'Mensagem enviada',
        contactSuccessMessage: 'A sua mensagem foi enviada. Responderemos o mais breve possível.',
        contactErrorTitle: 'Falha no envio',
        contactErrorMessage: 'Não foi possível enviar a sua mensagem. Por favor, tente novamente.'
    },
    promo: {
        haveCode: 'Tem um código promocional?',
        placeholder: 'Introduza o código',
        apply: 'Aplicar',
        remove: 'Remover',
        applied: '{name} – {discount}',
        invalidCode: 'Código inválido ou expirado.',
        expired: 'Este código expirou.',
        notValidForPurchase: 'Este código não é válido para esta compra.',
        free: 'Grátis',
        percentOff: '{value}% de desconto',
        fixedOff: '{value} de desconto',
        useWhenSubscribe: 'Use esta oferta quando subscrever abaixo.',
        useWhenPurchase: 'Use este código ao comprar um título.',
        accessGranted: 'O acesso foi aplicado à sua conta.'
    }
}

export default messages

